// import { getallowedmenus, getallowedmenus2 } from "_services";
// import { Images } from "constants";
// import { UserContext } from "context";
// import { utils } from "helper";
// import { ConfirmModalFor } from "modals";
// import React, { useEffect, useState } from "react";
// import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
// import StorageService from "utils/StorageServices/StorageServices";

// const Sidebar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const {
//     setAllMenu,
//     globCompanyId,
//     setLrPermissions,
//     setMastersChild,
//     setSettingChild,
//     setReportChild,
//     setAccountingChild,
//     setLrDetialsFrom,
//     setDispatchIndent,
//     warningDetails,
//     setShowWarnning,
//     setToggleSidebar,
//     setTruckChild,
//     setNoAccessISOpen,
//     setWorkShopChild
//   } = React.useContext(UserContext);

//   const [menulist, setMenuList] = useState([]);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [indexOuter, setOuterIndex] = useState(null);
//   const [confirmModalShow, setConfirmModalShow] = useState(false);
//   const [nextLink, setNextLink] = useState("");

//   const companyIDSet = StorageService.getCompanyId();
//   const remainingDays = utils?.calculateRemainingDays(warningDetails.web_end_date);
//   // const noWebAccess = !warningDetails?.subscription_data?.web_access;

//   const noWebAccess = (() => {
//     const web_access = warningDetails?.subscription_data?.web_access;

//     if (!web_access) return true; // web_access hi nahi hai

//     const startDate = new Date(warningDetails?.subscription_start_date);
//     const webEndDate = new Date(startDate);
//     webEndDate.setDate(webEndDate.getDate() + web_access);

//     // ✅ Expiry us din ki raat 12 baje (23:59:59) hogi
//     webEndDate.setHours(23, 59, 59, 999);

//     const today = new Date();
//     const webRemainingDays = Math.ceil(
//       (webEndDate - today) / (1000 * 60 * 60 * 24)
//     );

//     return webRemainingDays <= 0; // true = no access, false = access hai
//   })();

//   const calculateRemainingDays = (endDate) => {
//     if (!endDate) return 0;

//     const today = new Date();
//     const end = new Date(endDate);
//     const diffMs = end - today;
//     const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

//     return diffDays >= 0 ? diffDays : 0;
//   };



//   // ── Fetch sidebar menu ──────────────────────────────────────────────────────
//   useEffect(() => {
//     if (
//       companyIDSet &&
//       companyIDSet !== "undefined" &&
//       companyIDSet !== undefined &&
//       companyIDSet !== null
//     ) {
//       getAllowSideBarMenu(companyIDSet);
//     }
//   }, [companyIDSet, globCompanyId]);

//   useEffect(() => {
//     setLrDetialsFrom("");
//   }, []);

//   // ── FIX: Auto-sync activeIndex with current URL ─────────────────────────────
//   // Jab direct URL navigate ho ya page reload ho, sahi parent active ho jaaye
//   useEffect(() => {
//     if (!menulist?.length) return;

//     const activeOuterIndex = menulist.findIndex((item) => {
//       // Direct link match
//       if (item?.link && location.pathname === item.link) return true;
//       // Child link match
//       if (item?.childs?.length) {
//         return item.childs.some(
//           (child) =>
//             child?.link &&
//             (location.pathname === child.link ||
//               location.pathname.startsWith(child.link))
//         );
//       }
//       return false;
//     });

//     if (activeOuterIndex !== -1) {
//       setActiveIndex(activeOuterIndex);
//     }
//   }, [location.pathname, menulist]);

//   // ── API ─────────────────────────────────────────────────────────────────────
//   async function getAllowSideBarMenu(companyIDSet) {
//     const res2 = await getallowedmenus2({ company_id: companyIDSet });

//     const getChildDataByLabel = (label) =>
//       res2?.data?.main_permission?.find((i) => i.label === label)?.childs || [];

//     setMenuList(res2?.data?.main_permission);
//     setAllMenu(res2?.data?.main_permission);
//     setLrPermissions(res2?.data?.main_permission?.find((i) => i?.label === "LR"));
//     setMastersChild(getChildDataByLabel("Masters"));
//     setSettingChild(getChildDataByLabel("Settings"));
//     setReportChild(getChildDataByLabel("Reports"));
//     setAccountingChild(getChildDataByLabel("Accounting"));
//     setTruckChild(getChildDataByLabel("Fleets"));
//     setWorkShopChild(getChildDataByLabel("Workshop"));
//   }

//   // ── Handlers ────────────────────────────────────────────────────────────────
//   const handleClick = (index) => {
//     setActiveIndex(index);
//   };

//   const handleNavLinkClick = (link, event, index) => {
//     if (remainingDays <= 0) {
//       event.preventDefault();
//       setShowWarnning(true);
//       return;
//     }

//     if (noWebAccess) {
//       event.preventDefault();
//       setNoAccessISOpen(true);
//       return;
//     }

//     event.preventDefault();

//     if (
//       location?.pathname === "/trip/addtrip/createtrip2" ||
//       location?.pathname === "/invoicing/createbillraise" ||
//       location?.pathname === "/invoicing/selectlr" ||
//       location?.pathname === "/invoicing/selectedlr" ||
//       location?.pathname === "/invoicing/summary"
//     ) {
//       setNextLink(link);
//       setConfirmModalShow(true);
//       setOuterIndex(index);
//     } else {
//       setActiveIndex(index);
//       setDispatchIndent("");
//       navigate(link);
//     }
//   };

//   const handleConfirm = () => {
//     setDispatchIndent("");
//     setConfirmModalShow(false);
//     setActiveIndex(indexOuter);
//     navigate(nextLink);
//   };

//   const handleCancel = () => {
//     setConfirmModalShow(false);
//   };

//   let confirmModalProps = {
//     show: confirmModalShow,
//     closeModal: handleCancel,
//     title: "Leave This Page",
//     submitTitle: "Confirm",
//     onSubmit: handleConfirm,
//     confirmModal: "confirmModal",
//   };

//   // ── Render ───────────────────────────────────────────────────────────────────
//   return (
//     <aside className="sideBar">
//       <div className="_logoInx">
//         <img src={Images.LOGO2.default} alt="" />
//       </div>

//       <div className="menuBx_otr">
//         <ul className="_simpList accordion" id="accordionExample">
//           {menulist &&
//             menulist?.map((item, outerIndex) => {
//               const filterChild = item?.childs?.filter((c) => c?.web === 1);

//               const nonCollapsibleItems = ["Quick Uploads", "Accounting", "Reports"];
//               const isNonCollapsible = nonCollapsibleItems.includes(item?.label);

//               // Settings — special case
//               if (
//                 item?.label === "Settings" &&
//                 item?.childs?.length > 0 &&
//                 item?.web === 1
//               ) {
//                 return (
//                   <li className="_clk_li" key={`sidemenubar_${outerIndex}`}>
//                     <NavLink
//                       to={filterChild[0].link || "#"}
//                       className={({ isActive }) => {
//                         const childLinks = filterChild.map((child) => child.link);
//                         const isChildActive =
//                           childLinks.includes(location.pathname) ||
//                           location.pathname.includes('/setting');
//                         return `_clk_a ${isActive || isChildActive ? "active" : ""}`;
//                       }}
//                       onClick={(event) =>
//                         handleNavLinkClick(filterChild[0].link, event, outerIndex)
//                       }
//                     >
//                       <i className={item?.icon}></i>
//                       <span>{item?.display_name}</span>
//                     </NavLink>
//                   </li>
//                 );
//               }

//               // Items without children or non-collapsible
//               if (
//                 !item?.childs ||
//                 !item?.child_type ||
//                 item?.display_name === "Settings"
//               ) {
//                 return (
//                   item?.web === 1 && (
//                     <li className="_clk_li" key={`sidemenubar_${outerIndex}`}>
//                       <NavLink
//                         to={item?.link || "#"}
//                         className={({ isActive }) =>
//                           `_clk_a ${isActive ? "active" : ""}`
//                         }
//                         onClick={(event) =>
//                           handleNavLinkClick(item?.link, event, outerIndex)
//                         }
//                       >
//                         <i className={item?.icon}></i>
//                         <span>{item?.display_name}</span>
//                       </NavLink>
//                     </li>
//                   )
//                 );
//               }

//               // Collapsible accordion items
//               return (
//                 item?.web === 1 && (
//                   <li
//                     className={`_clk_li accordion-item ${activeIndex === outerIndex ? "anvAccordian_active" : ""
//                       }`}
//                     key={`sidemenubar_${outerIndex}`}
//                   >
//                     <button
//                       className="accordion-button collapsed"
//                       type="button"
//                       data-bs-toggle="collapse"
//                       data-bs-target={`#${item?.label}${outerIndex}`}
//                       aria-expanded="false"
//                       aria-controls={`${item?.label}${outerIndex}`}
//                     >
//                       <i className={item?.icon}></i>
//                       <span>{item?.label}</span>
//                       <div className="_clk_chevron">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="5"
//                           height="8"
//                           viewBox="0 0 5 8"
//                           fill="none"
//                         >
//                           <path
//                             d="M4.36632 3.63368L0.968818 0.236182C0.853799 0.13001 0.721084 0.0769238 0.570674 0.0769238C0.420264 0.0769238 0.287549 0.13001 0.172529 0.236182C0.0575098 0.351201 0 0.483916 0 0.634326C0 0.784736 0.0575098 0.917451 0.172529 1.03247L3.17189 4.03183L0.172529 7.03118C0.0575098 7.1462 0 7.27892 0 7.42933C0 7.57974 0.0575098 7.71245 0.172529 7.82747C0.234463 7.8894 0.294185 7.93364 0.351694 7.96019C0.409204 7.98673 0.482197 8 0.570674 8C0.65915 8 0.732144 7.98673 0.789653 7.96019C0.847163 7.93364 0.906885 7.8894 0.968818 7.82747L4.36632 4.42997C4.48134 4.31495 4.53885 4.18224 4.53885 4.03183C4.53885 3.88142 4.48134 3.7487 4.36632 3.63368Z"
//                             fill="white"
//                           />
//                         </svg>
//                       </div>
//                     </button>

//                     <div
//                       id={`${item?.label}${outerIndex}`}
//                       className="accordion-collapse collapse"
//                       aria-labelledby="headingOne"
//                       data-bs-parent="#accordionExample"
//                     >
//                       <h5 className="_clsk_head">{item?.display_name}</h5>
//                       <div className="accordion-body">
//                         <ul className="submenuUl">
//                           {item?.childs?.map((child, childIndex) => {
//                             if (child?.web !== 1 || child?.label === "Transactions") return null;
//                             return (
//                               <li key={`childmenu_${childIndex}`}>
//                                 <NavLink
//                                   to={child?.link || "#"}
//                                   className={({ isActive }) =>
//                                     `${isActive ? "active" : ""}`
//                                   }
//                                   onClick={(event) =>
//                                     handleNavLinkClick(child?.link, event, outerIndex)
//                                   }
//                                 >
//                                   <i className={child?.icon}></i>
//                                   <span>{child.display_name}</span>
//                                 </NavLink>
//                               </li>
//                             );
//                           })}
//                         </ul>
//                       </div>
//                     </div>
//                   </li>
//                 )
//               );
//             })}
//         </ul>
//       </div>

//       {confirmModalShow && (
//         <ConfirmModalFor {...confirmModalProps}>
//           <p className="_confirmPrx">Do you really want to leave this Page?</p>
//         </ConfirmModalFor>
//       )}
//     </aside>
//   );
// };

// export default Sidebar;

import { getallowedmenus, getallowedmenus2 } from "_services";
import { PremiumPopup } from "components/common";
import { Images } from "constants";
import { UserContext } from "context";
import { utils } from "helper";
import { ConfirmModalFor } from "modals";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    setAllMenu,
    globCompanyId,
    setLrPermissions,
    setMastersChild,
    setSettingChild,
    setReportChild,
    setAccountingChild,
    setLrDetialsFrom,
    setDispatchIndent,
    warningDetails,
    setShowWarnning,
    setToggleSidebar,
    setTruckChild,
    setNoAccessISOpen,
    setWorkShopChild,
  } = React.useContext(UserContext);

  const [menulist, setMenuList] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [indexOuter, setOuterIndex] = useState(null);
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [nextLink, setNextLink] = useState("");
  const [showPremiumPopup, setShowPremiumPopup] = useState(false);

  const companyIDSet = StorageService.getCompanyId();
  const remainingDays = utils?.calculateRemainingDays(
    warningDetails.web_end_date
  );

  const noWebAccess = (() => {
    const web_access = warningDetails?.subscription_data?.web_access;
    if (!web_access) return true;

    const startDate = new Date(warningDetails?.subscription_start_date);
    const webEndDate = new Date(startDate);
    webEndDate.setDate(webEndDate.getDate() + web_access);
    webEndDate.setHours(23, 59, 59, 999);

    const today = new Date();
    const webRemainingDays = Math.ceil(
      (webEndDate - today) / (1000 * 60 * 60 * 24)
    );

    return webRemainingDays <= 0;
  })();

  // ── Helpers ──
  const isVisibleInSidebar = (item) =>
    item?.web === 1 || item?.premium === 1;

  const isPremiumLocked = (item) =>
    item?.premium === 1 && item?.web !== 1;

  // ── Fetch sidebar menu ──
  useEffect(() => {
    if (
      companyIDSet &&
      companyIDSet !== "undefined" &&
      companyIDSet !== undefined &&
      companyIDSet !== null
    ) {
      getAllowSideBarMenu(companyIDSet);
    }
  }, [companyIDSet, globCompanyId]);

  useEffect(() => {
    setLrDetialsFrom("");
  }, []);

  useEffect(() => {
    if (!menulist?.length) return;

    const activeOuterIndex = menulist.findIndex((item) => {
      if (item?.link && location.pathname === item.link) return true;
      if (item?.childs?.length) {
        return item.childs.some(
          (child) =>
            child?.link &&
            (location.pathname === child.link ||
              location.pathname.startsWith(child.link))
        );
      }
      return false;
    });

    if (activeOuterIndex !== -1) {
      setActiveIndex(activeOuterIndex);
    }
  }, [location.pathname, menulist]);

  async function getAllowSideBarMenu(companyIDSet) {
    const res2 = await getallowedmenus2({ company_id: companyIDSet });

    const getChildDataByLabel = (label) =>
      res2?.data?.main_permission?.find((i) => i.label === label)?.childs || [];

    setMenuList(res2?.data?.main_permission);
    setAllMenu(res2?.data?.main_permission);
    setLrPermissions(
      res2?.data?.main_permission?.find((i) => i?.label === "LR")
    );
    setMastersChild(getChildDataByLabel("Masters"));
    setSettingChild(getChildDataByLabel("Settings"));
    setReportChild(getChildDataByLabel("Reports"));
    setAccountingChild(getChildDataByLabel("Accounting"));
    setTruckChild(getChildDataByLabel("Fleets"));
    setWorkShopChild(getChildDataByLabel("Workshop"));
  }

  const handleClick = (index) => {
    setActiveIndex(index);
  };

  const handleNavLinkClick = (link, event, index, item) => {
    event.preventDefault();

    // ── Premium check FIRST ──
    if (item && isPremiumLocked(item)) {
      setShowPremiumPopup(true);
      return;
    }

    if (remainingDays <= 0) {
      setShowWarnning(true);
      return;
    }

    if (noWebAccess) {
      setNoAccessISOpen(true);
      return;
    }

    if (
      location?.pathname === "/trip/addtrip/createtrip2" ||
      location?.pathname === "/invoicing/createbillraise" ||
      location?.pathname === "/invoicing/selectlr" ||
      location?.pathname === "/invoicing/selectedlr" ||
      location?.pathname === "/invoicing/summary"
    ) {
      setNextLink(link);
      setConfirmModalShow(true);
      setOuterIndex(index);
    } else {
      setActiveIndex(index);
      setDispatchIndent("");
      navigate(link);
    }
  };

  const handleConfirm = () => {
    setDispatchIndent("");
    setConfirmModalShow(false);
    setActiveIndex(indexOuter);
    navigate(nextLink);
  };

  const handleCancel = () => {
    setConfirmModalShow(false);
  };

  let confirmModalProps = {
    show: confirmModalShow,
    closeModal: handleCancel,
    title: "Leave This Page",
    submitTitle: "Confirm",
    onSubmit: handleConfirm,
    confirmModal: "confirmModal",
  };

  return (
    <aside className="sideBar">
      <div className="_logoInx">
        <img src={Images.LOGO2.default} alt="" />
      </div>

      <div className="menuBx_otr">
        <ul className="_simpList accordion" id="accordionExample">
          {menulist &&
            menulist?.map((item, outerIndex) => {
              const filterChild = item?.childs?.filter(
                (c) => c?.web === 1 || c?.premium === 1
              );

              const nonCollapsibleItems = [
                "Quick Uploads",
                "Accounting",
                "Reports",
              ];
              const isNonCollapsible = nonCollapsibleItems.includes(
                item?.label
              );

              const premiumLocked = isPremiumLocked(item);

              // Settings — special case
              if (
                item?.label === "Settings" &&
                item?.childs?.length > 0 &&
                isVisibleInSidebar(item)
              ) {
                return (
                  <li className="_clk_li" key={`sidemenubar_${outerIndex}`}>
                    <NavLink
                      to={filterChild[0]?.link || "#"}
                      className={({ isActive }) => {
                        const childLinks = filterChild.map(
                          (child) => child.link
                        );
                        const isChildActive =
                          childLinks.includes(location.pathname) ||
                          location.pathname.includes("/setting");
                        return `_clk_a ${
                          isActive || isChildActive ? "active" : ""
                        }`;
                      }}
                      onClick={(event) =>
                        handleNavLinkClick(
                          filterChild[0]?.link,
                          event,
                          outerIndex,
                          item
                        )
                      }
                    >
                      <i className={item?.icon}></i>
                      <span>{item?.display_name}</span>
                    </NavLink>
                  </li>
                );
              }

              // Items without children or non-collapsible
              if (
                !item?.childs ||
                !item?.child_type ||
                item?.display_name === "Settings"
              ) {
                return (
                  isVisibleInSidebar(item) && (
                    <li className="_clk_li" key={`sidemenubar_${outerIndex}`}>
                      <NavLink
                        to={item?.link || "#"}
                        className={({ isActive }) =>
                          `_clk_a ${isActive ? "active" : ""}`
                        }
                        onClick={(event) =>
                          handleNavLinkClick(
                            item?.link,
                            event,
                            outerIndex,
                            item
                          )
                        }
                      >
                        <i className={item?.icon}></i>
                        <span>{item?.display_name}</span>
                      </NavLink>
                    </li>
                  )
                );
              }

              // Collapsible accordion items
              return (
                isVisibleInSidebar(item) && (
                  <li
                    className={`_clk_li accordion-item ${
                      activeIndex === outerIndex ? "anvAccordian_active" : ""
                    }`}
                    key={`sidemenubar_${outerIndex}`}
                  >
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle={premiumLocked ? "" : "collapse"}
                      data-bs-target={
                        premiumLocked ? "" : `#${item?.label}${outerIndex}`
                      }
                      aria-expanded="false"
                      aria-controls={`${item?.label}${outerIndex}`}
                      onClick={(e) => {
                        if (premiumLocked) {
                          e.preventDefault();
                          setShowPremiumPopup(true);
                        }
                      }}
                    >
                      <i className={item?.icon}></i>
                      <span>{item?.label}</span>
                      <div className="_clk_chevron">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="5"
                          height="8"
                          viewBox="0 0 5 8"
                          fill="none"
                        >
                          <path
                            d="M4.36632 3.63368L0.968818 0.236182C0.853799 0.13001 0.721084 0.0769238 0.570674 0.0769238C0.420264 0.0769238 0.287549 0.13001 0.172529 0.236182C0.0575098 0.351201 0 0.483916 0 0.634326C0 0.784736 0.0575098 0.917451 0.172529 1.03247L3.17189 4.03183L0.172529 7.03118C0.0575098 7.1462 0 7.27892 0 7.42933C0 7.57974 0.0575098 7.71245 0.172529 7.82747C0.234463 7.8894 0.294185 7.93364 0.351694 7.96019C0.409204 7.98673 0.482197 8 0.570674 8C0.65915 8 0.732144 7.98673 0.789653 7.96019C0.847163 7.93364 0.906885 7.8894 0.968818 7.82747L4.36632 4.42997C4.48134 4.31495 4.53885 4.18224 4.53885 4.03183C4.53885 3.88142 4.48134 3.7487 4.36632 3.63368Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </button>

                    {!premiumLocked && (
                      <div
                        id={`${item?.label}${outerIndex}`}
                        className="accordion-collapse collapse"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <h5 className="_clsk_head">{item?.display_name}</h5>
                        <div className="accordion-body">
                          <ul className="submenuUl">
                            {item?.childs?.map((child, childIndex) => {
                              if (
                                !isVisibleInSidebar(child) ||
                                child?.label === "Transactions"
                              )
                                return null;

                              return (
                                <li key={`childmenu_${childIndex}`}>
                                  <NavLink
                                    to={child?.link || "#"}
                                    className={({ isActive }) =>
                                      `${isActive ? "active" : ""}`
                                    }
                                    onClick={(event) =>
                                      handleNavLinkClick(
                                        child?.link,
                                        event,
                                        outerIndex,
                                        child
                                      )
                                    }
                                  >
                                    <i className={child?.icon}></i>
                                    <span>{child.display_name}</span>
                                  </NavLink>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    )}
                  </li>
                )
              );
            })}
        </ul>
      </div>

      {confirmModalShow && (
        <ConfirmModalFor {...confirmModalProps}>
          <p className="_confirmPrx">Do you really want to leave this Page?</p>
        </ConfirmModalFor>
      )}

      {/* Premium Feature Popup */}
      <PremiumPopup
        isOpen={showPremiumPopup}
        closeModal={() => setShowPremiumPopup(false)}
        title="Premium Feature"
        message="This feature is part of our premium plan. Upgrade now to unlock it."
        submitTitle="Upgrade Now"
        onSubmit={() => {
          setShowPremiumPopup(false);
          // navigate("/upgrade"); // wire your upgrade route
        }}
      />
    </aside>
  );
};

export default Sidebar;